@import "@/ui/variables.css";

.selectRoot {
  background-color: var(--gray-light);
  border-radius: var(--radius);
  border: none;
  color: var(--white);
  font-family: var(--font);
  font-size: 0.9rem;
  padding: var(--space-1) var(--space-2);
  width: 100%;

  &[data-variant="soft"] {
    background-color: oklch(from var(--gray-light) calc(l + 0.6) c h);
    border: 1px solid var(--gray-lighter);
    color: var(--gray-dark);
  }
}
